module.exports = __webpack_public_path__ + "img/a5.081b5847.png";